import KunLoading48 from './src/index'

KunLoading48.install = function (Vue) {
	Vue.component(KunLoading48.name, KunLoading48);
}

export default KunLoading48;
